<template>
  <div id="news">
    <h1>{{ $t('news') }}</h1>
    <div v-if="recentPostsLoaded">
      <NewsCard v-for="(post, index) of recentPosts(limit)" :key="index"
        :index="index"
        :title="post.title.rendered"
        :content="post.content.rendered"
        :UtcDate="post.date_utc"
        :link="post.slug"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NewsCard from "@/components/News/NewsCard.vue";

export default {
  components: {
    NewsCard,
  },
  data() {
    return {
      limit: 5,
    };
  },
  computed: {
    ...mapGetters({
      recentPosts: "recentPosts",
      recentStickyPosts: "recentStickyPosts",
      recentPostsLoaded: "recentPostsLoaded",
    }),
  },
  mounted() {
    this.getPosts(this.$i18n.locale);
  },
  methods: {
    getPosts(lang) {
      this.$store.dispatch("getPosts", { limit: this.limit, lang });
    },
  },
  watch: {
    '$i18n.locale' () {
      this.getPosts(this.$i18n.locale);
    }
  },
}
</script>

<style lang="scss" scoped>
#news {
  padding-bottom: 4px;
  padding-top: 50px;
}

h1 {
  padding-top: 50px;
  margin-bottom: 30px;
}

@media (min-width: $mobile-vw) {
  #news {
    padding-bottom: 0;
    padding-top: 0;
  }

  h1 {
    padding-top: 70px;
    margin-bottom: 60px;
  }
}
</style>